import { useDioxus } from '@/lib/wasm'

export function LoadingHomePage() {
  const ref = useDioxus('mount_loading_home_page')
  return <div ref={ref} className="contents" />
}
